import React from "react";
import { Box, Typography } from "@mui/material";
import { WizardShell } from "../../../../../components/ui";
import { TOPIC_STEPS } from "../../wizard-steps";
import { SubClassType } from "../../index";
import { useSubClass } from "./use-sub-class";
import SelectableOptionRow from "../components/SelectableOptionRow";
import SelectionChip from "../../components/selection-chip";

type Props = {
    onFinish: () => void;
    onBack: () => void;
    subclass: SubClassType[];
};

export const SubClass: React.FC<Props> = ({ onFinish, onBack, subclass }) => {
    const { subClassType, selectedCount, handleContinue, handleOnChange, clearAll } = useSubClass(subclass, onFinish);

    return (
        <WizardShell steps={TOPIC_STEPS as unknown as string[]} activeIndex={2} onBack={onBack} onNext={handleContinue} nextLabel="Continuar">
            {/* Cabeçalho */}
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "12px", mb: "4px" }}>
                <Typography sx={{ fontFamily: "'DM Serif Display', serif", fontSize: 24, fontWeight: 400, color: "text.primary" }}>
                    Subclasses
                </Typography>
                <SelectionChip count={selectedCount} onClear={clearAll} />
            </Box>
            <Typography sx={{ fontSize: 13.5, color: "text.secondary", mb: "20px" }}>
                Selecione subclasses para refinar a busca de ativos. (Opcional)
            </Typography>

            {/* Lista por ativo */}
            <Box sx={{ maxHeight: "55vh", overflowY: "auto", display: "flex", flexDirection: "column", gap: "20px" }}>
                {subClassType.map((types, groupIndex) => (
                    <Box key={groupIndex}>
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "text.secondary",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                mb: "8px",
                            }}
                        >
                            {types.active}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            {types.checkableSubClass.map((item, index) => (
                                <SelectableOptionRow
                                    key={item.value.id ?? index}
                                    label={item.value.name}
                                    selected={item.isSelected}
                                    onClick={() => handleOnChange(item.value, !item.isSelected)}
                                />
                            ))}
                        </Box>
                    </Box>
                ))}
            </Box>
        </WizardShell>
    );
};
